'use strict';

/**
 * Quiz in-card flow. An Antavo quiz is a single question: the card CTA
 * fetches the question, one answer is submitted, and the response is the
 * graded result. All markup arrives server-rendered, so this module only
 * swaps fragments and posts the answer.
 *
 * The submitted answer is the option's ZERO-BASED INDEX, read from
 * data-value, not its text — Antavo's quiz answers are a flat array of plain
 * strings with no IDs, so the earn endpoint takes the position in that array.
 * The correct answer is never present in the DOM: the server strips it from
 * the quiz detail before rendering the question.
 */

var flowAjax = require('./_flowAjax');

/**
 * @param {jQuery} $flow - The flow container
 * @returns {string|null} - The selected option's index as a string, or null
 */
function currentAnswer($flow) {
    var $selected = $flow.find('.js-quiz-option.selected');
    return $selected.length ? $selected.attr('data-value') : null;
}

module.exports = {
    /**
     * Wires the delegated quiz-flow events.
     */
    init: function () {
        // Card CTA: fetch the question. The options are not in the card, so
        // this round trip is what reveals them — see quizCard.isml for why
        // they are not rendered with the grid.
        $('body').on('click', '.js-quiz-start', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var $card = $btn.closest('.js-loyalty-activity-card');

            $btn.prop('disabled', true);
            flowAjax.post({
                url: $btn.attr('data-url'),
                data: flowAjax.withCsrf($card, { quizId: $btn.attr('data-quiz-id') }),
                $card: $card,
                $restore: $btn
            });
        });

        // Option select: a quiz takes exactly one answer, so selecting
        // replaces rather than toggles. aria-pressed mirrors the selected
        // class for assistive tech.
        $('body').on('click', '.js-quiz-flow .js-quiz-option', function (e) {
            e.preventDefault();
            var $option = $(this);
            var $flow = $option.closest('.js-quiz-flow');

            $flow.find('.js-quiz-option').removeClass('selected').attr('aria-pressed', 'false');
            $option.addClass('selected').attr('aria-pressed', 'true');
            $flow.find('.js-quiz-submit').prop('disabled', false);
        });

        // Submit the answer; the response is the graded result.
        $('body').on('click', '.js-quiz-flow .js-quiz-submit', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var $flow = $btn.closest('.js-quiz-flow');
            var $card = $flow.closest('.js-loyalty-activity-card');
            var answer = currentAnswer($flow);

            if (answer === null) {
                return;
            }

            $btn.prop('disabled', true);
            flowAjax.post({
                url: $flow.attr('data-answer-url'),
                data: flowAjax.withCsrf($card, {
                    quizId: $flow.attr('data-quiz-id'),
                    answer: answer,
                    // Lets the route reject an obviously malformed index
                    // without a round trip to Antavo. A hint, not a bound —
                    // Antavo grades the answer either way.
                    answerCount: $flow.attr('data-answer-count')
                }),
                $card: $card,
                $restore: $btn
                // No success toast. The result fragment that replaces the card
                // already carries Antavo's own message, so announcing it again
                // in a toast said the same thing twice.
            });
        });
    }
};
